/**
 * @file 存放数据
 */


// 保存取车城市action
const SAVE_CITY_GAI_INFO = param => {
    return async (dispatch) => {
        dispatch({
            type: 'SAVE_CITY_GAI_INFO',
            data: param
        });
    };
};

// 保存还车城市action
const SAVE_CITY_GET_INFO = param => {
    return async (dispatch) => {
        dispatch({
            type: 'SAVE_CITY_GET_INFO',
            data: param
        });
    };
};

// 保存取车门店action
const SAVE_STORE_GAI_INFO = param => {
    return async (dispatch) => {
        dispatch({
            type: 'SAVE_STORE_GAI_INFO',
            data: param
        });
    };
};

// 保存还车门店action
const SAVE_STORE_GET_INFO = param => {
    return async (dispatch) => {
        dispatch({
            type: 'SAVE_STORE_GET_INFO',
            data: param
        });
    };
};

// 保存取车开始时间
const SAVE_START_TIME = param => {
    return async (dispatch) => {
        dispatch({
            type: 'SAVE_START_TIME',
            data: param
        });
    };
};

// 保存取车结束时间
const SAVE_END_TIME = param => {
    return async (dispatch) => {
        dispatch({
            type: 'SAVE_END_TIME',
            data: param
        });
    };
};

export {
    SAVE_CITY_GAI_INFO,
    SAVE_CITY_GET_INFO,
    SAVE_STORE_GAI_INFO,
    SAVE_STORE_GET_INFO,
    SAVE_START_TIME,
    SAVE_END_TIME
};
